import { render } from "./SectionCardBody.vue?vue&type=template&id=17bb328c"
import script from "./SectionCardBody.vue?vue&type=script&lang=js"
export * from "./SectionCardBody.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__